import React, { Suspense } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Privacy from "./Pages/Privacy";
import Error from "./Pages/Error";
import Contact from "./Pages/Contact";
import Terms from "./Pages/Terms";
import AccessibilityStatement from "./Pages/AccessibilityStatement";
import Navigation from "./components/Navigation";
import ClosoureMap from "./components/ClosureMap";
// import CrossingsMap from "./components/CrossingsMap";
import CamerasMap from "./components/CamerasMap";
import Spinners from "./components/Spinners";
import "leaflet.markercluster/dist/MarkerCluster.css";
import Admindashboard from "./components/Admindashboard";
import Footer from "./components/Footer";

const CrossingsMap = React.lazy(() => import("./components/CrossingsMap"));

// const loading = (
//   <Spinner animation="border" role="status">
//   <span className="visually-hidden">Loading...</span>
// </Spinner>
// );

function App() {
  return (
    <Router>
      <div className="App">
        <Suspense fallback={<Spinners />}>
          <Navigation />
          <Routes>
            <Route
              path="/"
              element={
                <Home>
                  <ClosoureMap />
                </Home>
              }
            />
            <Route
              path="/crossings"
              element={
                <Home>
                  <CrossingsMap />
                </Home>
              }
            />
            <Route
              path="/cameras"
              element={
                <Home>
                  <CamerasMap />
                </Home>
              }
            />
            <Route path="/about" element={<About />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="contact" element={<Contact />} />
            <Route path="admin-dashboard" element={<Admindashboard />} />
            <Route path="/accessibility" element={<AccessibilityStatement />} />
            <Route path="*" element={<Error />} />
          </Routes>
          <Footer />
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
